import React from "react";
import "./style/ContextMenu.css";

const ContextMenu = ({ xPos, yPos, editComment, deleteHighlight }) => {
  return (
    <div className="context-menu" style={{ top: yPos + 2, left: xPos + 2 }}>
      <button onClick={editComment}>编辑</button>
      <button onClick={deleteHighlight}>删除</button>
    </div>
  );
};

export default ContextMenu;
